import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-actions-dropdown',
  templateUrl: './actions-dropdown.component.html',
  styleUrls: ['./actions-dropdown.component.scss']
})
export class ActionsDropdownComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
